
  import { createRoot } from "react-dom/client";
  import App from "./app/App.tsx";
  import "./styles/index.css";
  import "@fontsource/space-grotesk/latin-400.css";
  import "@fontsource/space-grotesk/latin-500.css";
  import "@fontsource/space-grotesk/latin-600.css";
  import "@fontsource/space-grotesk/latin-700.css";
  import "@fontsource/syne/latin-600.css";
  import "@fontsource/syne/latin-700.css";
  import "@fontsource/syne/latin-800.css";

  createRoot(document.getElementById("root")!).render(<App />);
  